import { CanDeactivateFn } from '@angular/router'
import { inject } from '@angular/core'
import { MatDialog } from '@angular/material/dialog'
import { Observable, map } from 'rxjs'
import { ConfirmDialogComponent } from './confirm-dialog/confirm-dialog.component'
import { TranslateService } from '@ngx-translate/core'

export type ComponentWithUnsavedChanges = {
  hasUnsavedChanges: boolean
}

export const unsavedChangesGuard: CanDeactivateFn<ComponentWithUnsavedChanges> = (component) => {
  if (!component.hasUnsavedChanges) {
    return true
  }

  const dialog = inject(MatDialog)
  const translateService = inject(TranslateService)

  const dialogRef = dialog.open(ConfirmDialogComponent, {
    data: {
      title: translateService.instant('TEMPLATES.UNSAVED_CHANGES_DIALOG.TITLE'),
      description: translateService.instant('TEMPLATES.UNSAVED_CHANGES_DIALOG.DESCRIPTION'),
      confirmLabel: translateService.instant('TEMPLATES.UNSAVED_CHANGES_DIALOG.LEAVE'),
      cancelLabel: translateService.instant('TEMPLATES.UNSAVED_CHANGES_DIALOG.STAY'),
    },
  })

  return dialogRef.afterClosed().pipe(map((confirmed) => confirmed === true)) as Observable<boolean>
}
